import { Link } from "react-router-dom";

import { GET_STARTED } from "../../../routes/paths";
import useMediaSize from "../../../hooks/useMediaSize";
import bgMobileImg from "../../../assets/images/homePage/good-pets-mobile.png"
import bgDesktopImg from "../../../assets/images/homePage/good-pets-desktop.png"

import styles from "./styles.module.scss";
import { useLocalizedPath } from "../../../seo/useLocalizedPath";

const GoodPetsWP = () => {
  const { isMobile } = useMediaSize();
  const localizePath = useLocalizedPath();

  return (
    <div className={styles.imgWrapper}>
      <Link to={localizePath(GET_STARTED)}>
        <img className={styles.bgImg} src={ isMobile ? bgMobileImg : bgDesktopImg } alt="" />
      </Link>
    </div>
  );
};

export default GoodPetsWP;
